import { style } from "@vanilla-extract/css";

export const fanLeagueBadge = style({
  width: "100px",
  height: "100px",
});
